import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDz856nGtGPMnYUk1Ca6kg7vbqf8uJQKp0",
  authDomain: "tracker-live-zero.firebaseapp.com",
  projectId: "tracker-live-zero",
  storageBucket: "tracker-live-zero.firebasestorage.app",
  messagingSenderId: "809535576267",
  appId: "1:809535576267:web:c7c09570cfb595826fe34e",
  measurementId: "G-F06KQD8W67"
};


const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);